import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import counterReducer from '../components/counter/counterSlice';
import eventReducer from './slices/eventsSlice';
import userReducer from './slices/userSlice';
import featuresReducer from './slices/featuresSlice';
import overridesReducer from './slices/overridesSlice';
import configsReducer from './slices/configsSlice';
import reportReducer from './slices/reportSlice';
import quarantineReducer from './slices/quarantineSlice';
import processingLabReducer from './slices/processingLabSlice';
import photoDayImportReducer from './slices/photoDayImportSlice';
import { combineReducers } from '@reduxjs/toolkit';

const reducer = combineReducers({
  counter: counterReducer,
  event: eventReducer,
  user: userReducer,
  features: featuresReducer,
  overrides: overridesReducer,
  configs: configsReducer,
  report: reportReducer,
  quarantine: quarantineReducer,
  processingLab: processingLabReducer,
  photoDayImport: photoDayImportReducer 
});

export const store = configureStore({ reducer });

export const testStore = (preloadedState?: Partial<RootState>) =>
  configureStore({
    reducer,
    preloadedState,
  });

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
